// extracted by mini-css-extract-plugin
export default {"container":"solutionSelection_container__n2ICp","solutions":"solutionSelection_solutions__lDzUD"};